import { css, styled } from 'styled-components';
import { BreakPoint } from 'styles/style-variables/breakpoint';

import { SText } from 'components/styled/SText';

export const Wrapper = styled.div<{ $isSmallSize?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $isSmallSize }) => ($isSmallSize ? '8px' : '12px')};
  max-width: fit-content;
  padding: ${({ $isSmallSize }) => ($isSmallSize ? '12px' : '12px 24px')};
  border-radius: ${({ $isSmallSize }) => ($isSmallSize ? '12px' : '48px')};
  background-color: #fff6d9;

  @media (max-width: ${BreakPoint.MobileTop}) {
    gap: 8px;
    padding: 12px;
    border-radius: 12px;
  }

  & svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }
`;

export const Text = styled(SText)<{ $isSmallSize?: boolean }>`
  font-size: 14px;
  line-height: 20px;

  @media (max-width: ${BreakPoint.MobileTop}) {
    font-size: 10px;
    line-height: 14px;
    letter-spacing: 0.2px;
  }

  ${({ $isSmallSize }) => {
    if ($isSmallSize) {
      return css`
        font-size: 10px;
        line-height: 14px;
        letter-spacing: 0.2px;
      `;
    }
  }}
`;
